export default __webpack_public_path__ + "static/media/hoso-maki-avokado.1aa797ef.jpg";